import React from "react";
import {Box} from "@material-ui/core";
import {BoxProps} from "@material-ui/core/Box/Box";

export const Styled: React.ComponentType<BoxProps> =
  (props) => <Box clone {...props} />;
